import React, { useEffect, useRef, useState } from "react";

import {
  Accordion,
  Button,
  Col,
  Form,
  OverlayTrigger,
  ProgressBar,
  Row,
  Tab,
  Tabs,
  Tooltip,
} from "react-bootstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import {
  postData,
  getData,
  postFormData,
  deleteData,
} from "../../../axios/apiHelper";
import { postData as postDataRd} from "../../../axios/apiInstanceHelper";
import { ENDPOINT } from "../../../axios/apiConfig";
import { loader } from "../../../loader";
import { toast } from "react-toastify";
import { Spinner } from "react-activity";
import { popup_alert } from "../../../popup_alert";
import CommonConfirmModel from "../../../Model/CommonConfirmModel";
import axios from "axios";
import { connect } from "react-redux";
import { getEmailData, getDraftData, getSelectedSmartListData,getSelected } from "../../../actions";
import TrialCompletionTable from "../../R&D/TrialCompletionTable";
let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;

const TrailReadersView = (props) => {
  const accountMapping={"56Ek4feL/1A8mZgIKQWEqg==":2147501188,"bWmUjqX7J011   WUTYn9g==":298217,"MXl8m36VZFYXpgFVz3Pg0g==":2147537506,"HPW6EwQy6v8VrfnMsjz8tg==":2147634806}
  const rdLikeArray=["56Ek4feL/1A8mZgIKQWEqg==","bWmUjqX7J011   WUTYn9g==","MXl8m36VZFYXpgFVz3Pg0g==","HPW6EwQy6v8VrfnMsjz8tg=="]
  const isLikeRdAccount= rdLikeArray.includes(localStorage.getItem("user_id"))
  let obj = {};
  const limit = 24;
  const navigate = useNavigate();
  const { state } = useLocation()
  const deletButtonColor =isLikeRdAccount ? '#8A4E9C' : '#0066be'
  const isRDAccount = isLikeRdAccount
  const [search, setSearch] = useState("");
  const [lastSync, setLastSync] = useState("");
  const [readerDataList, setReaderDataList] = useState([]);
  const [country, setCountry] = useState([]);
  const [consetCountry, setConsetCountry] = useState({});
  const [isFlag, setFlag] = useState(0);
  const [isLoaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [activeTabs, setActiveTabs] = useState({});
  const institutionData = [
    {
      label: "Study site",
      value: "Study site",
    },
    {
      label: "Premier Research",
      value: "Premier Research",
    },
    {
      label: "Comac",
      value: "Comac",
    },
    {
      label: "Octapharma",
      value: "Octapharma",
    },
  ];
  const [totalCount, setCount] = useState(0);
 
  const [appliedFilter, setAppliedFilter] = useState({});
  const [filterObject, setFilterObject] = useState({});
  const [apifilterObject, setApifilterObject] = useState({});
  const [filterApplyflag, setFilterApplyflag] = useState(1);
  const [pageAll, setPageAll] = useState(false);
  const [siteNumber, setSiteNumber] = useState([]);
  const [siteName, setSiteName] = useState([]);
  const [changeUpdateFlag, setChangeUpdateFlag] = useState([]);
  const [countryAll, setCountryAll] = useState([]);
  const [irtCountry, setIRTCountry] = useState([]);
  const defaultCountry = useRef(null);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [selectedSiteName, setSelectedSiteName] = useState([]);
  const [selectedSiteNumber, setSelectedSiteNumber] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [totalCountFlag, setTotalCountFlag] = useState(true);
  const [filterdata, setFilterData] = useState({
  });
  const [originalFilterData, setOriginalFilterData] = useState({
    role: "",
  });
  const [apiFilterData, setApiFilterData] = useState({});

  const [forceRender, setForceRender] = useState(false);
  const [updateflag, setUpdateFlag] = useState(0);

  let types = [
    { value: "0", label: "HCP" },
    { value: "1", label: "Staff User" },
    { value: "3", label: "Test User" },
    { value: "4", label: "Competitor" },
  ];

  const [irtData, setIrtData] = useState([
    "All",
    "Site User-Blinded",
    "Investigator-Blinded",
    "Site unblinded pharmacist",
  ]);
  
  const [role, setRole] = useState((state != "undefined" && state?.siteRole != ""&& state?.siteRole != "All IRTs") ? [state?.siteRole] : irtData)
  const [rolePdf, setRolePdf] = useState(state?.pdfId ? state?.pdfId : 0)
  const [allMandatoryRole, setAllMandatoryRole] = useState([])
  const [change, setChanges] = useState(null);
  const userTypeValues = {
    0: "HCP",
    1: "Staff User",
    3: "Test User",
    4: "Competitor",
    5: "Pharma",
  };
  const [changeCountry, setChangeCountry] = useState([]);
  const [changeUserType, setChangeUserType] = useState([]);
  const [changeBlindedType, setChangeBlindedType] = useState([]);
  const [changeRoleType, setChangeRoleType] = useState([]);
  const [changeIRTType, setChangeIRTType] = useState([]);
  const [changeSiteNumberType, setChangeSiteNumberType] = useState([]);
  const [changeSiteNameType, setChangeSiteNameType] = useState([]);
  const [roleData, setRoleData] = useState([
    "All",
    "Principal Investigator",
    "Sub-Investigator",
    "Study Coordinator",
    "Study Nurse",
    "Other",
  ]);
  const [changeBlockReminderType, setBlockReminder] = useState([])
  const [showfilter, setShowFilter] = useState(false);
  const [emailStats, setEmailStats] = useState([]);
  const [statsFlag, setStatsFlag] = useState(0);
  const [spcFlag, setSpcFlag] = useState(0);
  const [apiCallStatus, setApiCallStatus] = useState(false);
  const [deletestatus, setDeleteStatus] = useState(false);
  const [resetDataId, setResetDataId] = useState();
  const [instituteValue, setInstitute] = useState([]);
  const [commonConfirmModelFun, setCommonConfirmModelFun] = useState(() => { });
  const [popupMessage, setPopupMessage] = useState({
    message1: "",
    message2: "",
    footerButton: "",
  });
  const [confirmationpopup, setConfirmationPopup] = useState(false);
  const buttonRef = useRef(null);
  const filterRef = useRef(null);
  const [refreshFlag, setRefreshFlag] = useState(false);
  let createdBy=localStorage.getItem("user_id")
  const [defaultOwner, setDefaultOwner] = useState("");
  let tooltipObj = {
    "New": "Not recieved the invite to training for this role yet. (data in usage can be from participating in previous role or non-mandatory content)",
    "Invited": "Has recieved the training email",
    "Started": "Started the training but not finished yet",
    "Completed": "Completed the training and received the certificate - nice.",
    "Ignored": "So far been ignoring the emails and training",
    "Not Completed": "Started some training, but not completed any and not responding to email nudges",
    "Blocked": "Have been blocked from participating in training",
  }
  const searchInputRef = useRef(null);
  useEffect(() => {
    if (isLikeRdAccount) {
      setFilterObject({});
      setApifilterObject({});
    }
    getFilters();

    function handleOutsideClick(event) {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        filterRef.current &&
        !filterRef.current.contains(event.target)
      ) {
        setShowFilter(false);
      }
    }

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    if(refreshFlag){
      getRefreshData();
    }
  },[refreshFlag])

  const getFilters = async () => {
    try {
      loader("show");
      const res = await getData(`${ENDPOINT.READERSFILTER}?irt=${1}&role=${state?.siteRole == 'All IRTs' ? 'all' : null}`);
      setCountry(res?.data?.data?.data?.country);
      setFilterData(res?.data?.data?.data);
      setApiFilterData(res?.data?.data?.data);
      if (
        res?.data?.data?.data["Content Owners"]?.length &&
        res?.data?.data?.defaultOwner && localStorage.getItem("user_id") !== "B7SHpAc XDXSH NXkN0rdQ=="
      ) {

        setAppliedFilter({
          ...appliedFilter,
          ["Content Owners"]: [res?.data?.data?.defaultOwner],
        });
        setFilterObject({
          ...filterObject,
          ["Content Owners"]: [res?.data?.data?.defaultOwner],
        });
        setApifilterObject({
          ...apifilterObject,
          ["Content Owners"]: [res?.data?.data?.defaultOwner],
        });
        setDefaultOwner(res?.data?.data?.defaultOwner);
      }

      setOriginalFilterData({
        ...originalFilterData,
        role: res?.data?.data?.data?.role,
      });
    } catch (err) {
      loader("hide");
    }
  };

  const getReaderListData = async () => {
    setIsLoaded(false);
    setRefreshFlag(false);
    setPageAll(false);
    setApiCallStatus(true);
    setTotalCountFlag(true);
  };
  const getDownloadData = async (page, obj, search) => {
    try {
      loader("show");
      let payload = {};

      let data = {
        user_id: localStorage.getItem("user_id"),
        userType: 5,
        search: search,
        type: "",
        page: 1,
      };

      if (localStorage.getItem("user_id") == "b3APser7L8OELDIG8ee2HQ==") {
        payload = {
          "contact Type": ["HCP"],
          ...data,
          ...filterObject,
          status: ["Registered"],
        };
      }
       else if (isLikeRdAccount) {
        payload = {
          status: ["Registered"],
          "contact Type": ["HCP"],
          'IRT mandatory training': ["Yes"],
          "role": role,
          ...data,
          ...filterObject,
        }
      }

      else {
        payload = { ...data, ...filterObject };
      }
      const res = await postFormData(ENDPOINT.NEW_READER_DOWNLOAD, payload, {
        responseType: "blob",
      });

      const link = document.createElement("a");
      const url = URL.createObjectURL(res?.data);
      link.href = url;
      link.download = "readers.xlsx";
      link.click();
      loader("hide");
    } catch (err) {
      console.log(err);
      loader("hide");
    }
  };

  const loadMoreClicked = () => {
    let sp = page + 1;
    getReaderListData(sp, filterObject, search, 1);
    if (isFlag == 1) {
      setPage(2);
    } else {
      setPage(sp);
    }
  };
  const searchChange = (e) => {
    setSearch(e?.target?.value);
    setFlag(0);

    if (e?.target?.value === "") {
      setReaderDataList([]);
      getReaderListData(page, filterObject, "");
    }
  };

  const submitHandler = (event) => {
    setReaderDataList([]);
    setTotalCountFlag(false);
    getReaderListData(page, filterObject, search);
    event.preventDefault();
    return false;
  };

  const handleOnFilterChange = (e, item, index, key, data = []) => {
    let newObj = JSON.parse(JSON.stringify(appliedFilter));
    if (isLikeRdAccount) {
      if (key == "IRT mandatory training") {
        if (newObj["role"]) {
          delete newObj["role"];
        }

        if (item == "Yes") {
          setFilterData({ ...filterdata, role: irtData });
        } else {
          setFilterData({ ...filterdata, role: roleData });
        }
      }
    }

    if (key == "Content Owners") {
      if (item == "IBU Owner") {
        let newData = [];

        delete apifilterObject?.["Business Unit"];
        delete newObj?.["Business Unit"];

        setFilterData({
          ...filterdata,
          "Business Unit": newData,
        });
      } else {
        setFilterData(apiFilterData);
      }
    }

    if (key == "status") {
      let newData = [];

      if (item == "Unregistered") {
        delete apifilterObject?.tags;
        delete apifilterObject?.["RTR?"];
        delete apifilterObject?.["Registered For Webinar"];
        delete apifilterObject?.["Registered For Title"];
        delete apifilterObject?.["Business Unit"];
        delete apifilterObject?.["Content Owners"];
        delete apifilterObject?.topic;

        delete filterObject.tags;
        delete filterObject?.["RTR?"];
        delete filterObject?.["Registered For Webinar"];
        delete filterObject?.["Registered For Title"];
        delete filterObject?.topic;

        delete newObj.tags;
        delete newObj?.["RTR?"];
        delete newObj?.["Content Owners"];

        delete newObj?.["Business Unit"];

        delete newObj?.["Registered For Webinar"];
        delete newObj?.["Registered For Title"];
        delete newObj?.topic;

        setFilterData({
          ...filterdata,
          tags: newData,
          "RTR?": newData,
          "Content Owners": newData,
          "Registered For Webinar": newData,
          "Business Unit": newData,
          "Registered For Title": newData,
          topic: newData,
        });
      } else {
        setFilterData(apiFilterData);
      }
    }

    if (!newObj[key]) {
      newObj[key] = [];
    }
    if (!apifilterObject[key]) {
      apifilterObject[key] = [];
    }

    if (key == "region") {
      let newCountry = [];
      if (item == "All") {
        newCountry = country;
        filterdata.country = [];
        delete apifilterObject.country;
        delete filterObject.country;
      } else {
        Object.keys(filterdata?.regionCountry)?.forEach((values) => {
          if (filterdata?.regionCountry[values] == item) {
            // newCountry.push(values);
            newCountry.push(
              values == "B&H" ? "Bosnia and Herzegovina" : values
            );
          }
        });
        delete apifilterObject.country;
        delete filterObject.country;
      }
      newCountry.sort((a, b) => {
        const countryA = a?.toLowerCase();
        const countryB = b?.toLowerCase();
        if (countryA < countryB) return -1;
        if (countryA > countryB) return 1;
        return 0;
      });
      setFilterData({ ...filterdata, country: newCountry });
    }

    if (e?.target?.checked == true) {
      if (
        key == "status" ||
        key == "contact Type" ||
        key == "userAction" ||
        key == "Business Unit" ||
        key == "webinarRegistered" ||
        key == "Registered For Webinar" ||
        key == "RTR?" ||
        key == "region" ||
        key == "IRT" ||
        key == "IRT mandatory training" ||
        key == "Blinded" ||
        key == "Content Owners" ||
        key == "List" 
        // ||
        // key == "Training"
      ) {
        if (key == "region") {
          newObj["country"] = [];
          newObj[key] = [];
          apifilterObject[key] = [];
          newObj[key]?.push(item);
          apifilterObject[key]?.push(e.target.value);
        } else {
          newObj[key] = [];
          apifilterObject[key] = [];
          newObj[key]?.push(item);
          apifilterObject[key]?.push(e.target.value);
        }
      } else {
        if (item == "All") {
          newObj[key] = data;
          apifilterObject[key] = data;
        } else {
          newObj[key]?.push(item);
          apifilterObject[key]?.push(item);
          if (data?.length - 1 == newObj[key]?.length && key != "site") {
            newObj[key]?.push("All");
            apifilterObject[key]?.push("All");
          }
        }
      }
    } else {
      if (item == "All") {
        newObj[key] = [];
      } else {
        if (newObj[key]?.includes("All")) {
          newObj[key] = newObj[key]?.filter((item) => item != "All");
        }
      }
      const index = newObj[key]?.indexOf(item);
      if (index > -1) {
        newObj[key]?.splice(index, 1);
        if (newObj[key]?.length == 0) {
          delete newObj[key];
        }
      }
      const index2 = apifilterObject[key]?.indexOf(e.target.value);
      if (index2 > -1) {
        apifilterObject[key]?.splice(index2, 1);
        if (apifilterObject[key]?.length == 0) {
          delete apifilterObject[key];
        }
      }
    }

    // setFilterObject(newObj);
    setAppliedFilter(newObj);
    setApifilterObject(apifilterObject);
    setForceRender(!forceRender);
  };

  function LinkWithTooltip({ id, children, href, tooltip }) {
    return (
      <OverlayTrigger
        overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
        placement="top"
        delayShow={300}
        delayHide={150}
      >
        <a href={href}>{children}</a>
      </OverlayTrigger>
    );
  }
  const onBlockReminderChange = (checked, id, index) => {
    const consetValue = checked == true ? 1 : 0;
    const consent = {
      index: id,
      value: consetValue,
    };
    const found = changeBlockReminderType.some((el) => el.index === id);

    if (!found) {
      setBlockReminder((oldArray) => [...oldArray, consent]);
    } else {
      setBlockReminder((oldArray) =>
        oldArray.map((el) =>
          el.index === id ? { ...el, value: consetValue } : el
        )
      );
    }
    changeUpdateFlag.push(id);
    setChangeUpdateFlag(changeUpdateFlag);

  }
  const onCountryChange = (e, i, index) => {
    setSelectedCountry((prev) => {
      const newSelectedSiteNumber = [...prev];
      newSelectedSiteNumber[index] = {
        value: e.value,
        label: e.value,
      };
      return newSelectedSiteNumber;
    });
    if (isLikeRdAccount) {
      let consent1 = {
        index: i,
        value: "",
      };
      const found2 = changeSiteNumberType.some((el) => el.index === i);
      if (!found2) {
        setChangeSiteNumberType((oldarray) => [...oldarray, consent1.value]);
      } else {
        const updatedArray = changeSiteNumberType.map((el) =>
          el.index === i ? { ...el, value: consent1.value } : el
        );
        setChangeSiteNumberType(updatedArray);
      }

      let consent2 = {
        index: i,
        value: "",
      };
      const found3 = changeSiteNameType.some((el) => el.index === i);
      if (!found3) {
        setChangeSiteNameType((oldarray) => [...oldarray, consent2.value]);
      } else {
        const updatedArray = changeSiteNameType.map((el) =>
          el.index === i ? { ...el, value: consent2.value } : el
        );
        setChangeSiteNameType(updatedArray);
      }
      setSelectedSiteNumber((prev) => {
        const newSelectedSiteNumber = [...prev];
        newSelectedSiteNumber[index] = true;
        return newSelectedSiteNumber;
      });

      setSelectedSiteName((prev) => {
        const newSelectedSiteName = [...prev];
        newSelectedSiteName[index] = true;
        return newSelectedSiteName;
      });

      let consetValue = e.value;
      const filteredData = change.sideData.filter(
        (item) => item.country === consetValue
      );

      const siteNumbers = filteredData.map((item) => ({
        label: item.site_number,
        value: item.site_number,
      }));
      const siteNames = filteredData.map((item) => ({
        label: item.site_name,
        value: item.site_name,
      }));
      setSiteNumber((prevSiteNumbers) => ({
        ...prevSiteNumbers,
        [index]: siteNumbers,
      }));
      setSiteName((prevSiteNumbers) => ({
        ...prevSiteNumbers,
        [index]: siteNames,
      }));
    }
    let consent = {
      index: i,
      value: e.value,
    };
    const found = changeCountry.some((el) => el.index === i);
    if (!found) {
      setChangeCountry((oldarray) => [...oldarray, consent]);
    } else {
      const updatedArray = changeCountry.map((el) =>
        el.index === i ? { ...el, value: e.value } : el
      );
      setChangeCountry(updatedArray);
    }
    changeUpdateFlag.push(i);
    setChangeUpdateFlag(changeUpdateFlag);
  };

  const onUserChange = (e, i) => {
    const consetValue = e.value;
    const consent = {
      index: i,
      value: consetValue,
    };
    const found = changeUserType.some((el) => el.index === i);

    if (!found) {
      setChangeUserType((oldArray) => [...oldArray, consent]);
    } else {
      setChangeUserType((oldArray) =>
        oldArray.map((el) =>
          el.index === i ? { ...el, value: consetValue } : el
        )
      );
    }
    changeUpdateFlag.push(i);
    setChangeUpdateFlag(changeUpdateFlag);
  };

  const onBlindedChange = (e, i) => {
    const consetValue = e.value;
    const consent = {
      index: i,
      value: consetValue,
    };
    const found = changeBlindedType.some((el) => el.index === i);

    if (!found) {
      setChangeBlindedType((oldArray) => [...oldArray, consent]);
    } else {
      setChangeBlindedType((oldArray) =>
        oldArray.map((el) =>
          el.index === i ? { ...el, value: consetValue } : el
        )
      );
    }
  };

  const onRoleChange = (e, i, index) => {
    const consetValue = e.value;
    setSelectedRole((prev) => {
      const newSelectedSiteName = [...prev];
      newSelectedSiteName[index] = {
        value: consetValue,
        label: consetValue,
      };
      return newSelectedSiteName;
    });

    const consent = {
      index: i,
      value: consetValue,
    };

    const found = changeRoleType.some((el) => el.index === i);

    if (!found) {
      setChangeRoleType((oldArray) => [...oldArray, consent]);
    } else {
      setChangeRoleType((oldArray) =>
        oldArray.map((el) =>
          el.index === i ? { ...el, value: consetValue } : el
        )
      );
    }
    changeUpdateFlag.push(i);
    setChangeUpdateFlag(changeUpdateFlag);
  };

  const onIrtChange = (e, i, index) => {
    setSelectedRole((prev) => {
      const newSelectedSiteName = [...prev];
      newSelectedSiteName[index] =
        e?.value == 1 ? change?.userIrtRoles[0] : change?.role[4];
      return newSelectedSiteName;
    });

    let consetValue = e.value;
    let consent = {
      index: i,
      value: parseInt(consetValue),
    };

    const foundIndex = changeIRTType.findIndex((el) => el.index === i);
    if (foundIndex === -1) {
      setChangeIRTType((oldarray) => [...oldarray, consent]);
    } else {
      setChangeIRTType((oldarray) =>
        oldarray.map((el) => {
          if (el.index === i) {
            return { ...el, value: parseInt(consetValue) };
          }
          return el;
        })
      );
    }

    if (selectedCountry?.length) {
      let newAr = selectedCountry;
      newAr[index] = {};
      setSelectedCountry(newAr);
    } else {
      let newAr = selectedCountry;
      newAr[index] = {};
      setSelectedCountry(newAr);
    }
    let consent1 = {
      index: i,
      value: "",
    };
    const found2 = changeSiteNumberType.some((el) => el.index === i);

    if (!found2) {
      setChangeSiteNumberType((oldarray) => [...oldarray, consent1.value]);
    } else {
      const updatedArray = changeSiteNumberType.map((el) =>
        el.index === i ? { ...el, value: consent1.value } : el
      );
      setChangeSiteNumberType(updatedArray);
    }

    const found3 = changeSiteNameType.some((el) => el.index === i);

    if (!found3) {
      setChangeSiteNameType((oldarray) => [...oldarray, consent1.value]);
    } else {
      const updatedArray = changeSiteNameType.map((el) =>
        el.index === i ? { ...el, value: consent1.value } : el
      );
      setChangeSiteNameType(updatedArray);
    }

    const consent2 = {
      index: i,
      value:
        e?.value == 1 ? change?.userIrtRoles[0]?.value : change?.role[4]?.value,
    };

    const found4 = changeRoleType.some((el) => el.index === i);

    if (!found4) {
      setChangeRoleType((oldarray) => [...oldarray, consent2]);
    } else {
      const updatedArray = changeRoleType.map((el) =>
        el.index === i ? { ...el, value: consent2.value } : el
      );
      setChangeRoleType(updatedArray);
    }
    const found5 = changeCountry.some((el) => el.index === i);
    if (!found5) {
      setChangeCountry((oldarray) => [...oldarray, consent1]);
    } else {
      const updatedArray = changeCountry.map((el) =>
        el.index === i ? { ...el, value: consent1.value } : el
      );
      setChangeCountry(updatedArray);
    }

    setSelectedSiteNumber((prev) => {
      const newSelectedSiteNumber = [...prev];
      newSelectedSiteNumber[index] = true;
      return newSelectedSiteNumber;
    });

    setSelectedSiteName((prev) => {
      const newSelectedSiteName = [...prev];
      newSelectedSiteName[index] = true;
      return newSelectedSiteName;
    });

    let siteNumbers = [];
    let siteNames = [];
    setSiteNumber((prevSiteNumbers) => ({
      ...prevSiteNumbers,
      [index]: siteNumbers,
    }));
    setSiteName((prevSiteNumbers) => ({
      ...prevSiteNumbers,
      [index]: siteNames,
    }));
    changeUpdateFlag.push(i);
    setChangeUpdateFlag(changeUpdateFlag);
  };

  const institutionFun = (e, i, index) => {
    let insitutedData = {
      index: i,
      value: e?.value,
    };
    const instituteIndex = instituteValue.findIndex((el) => el.index === i);
    if (instituteIndex === -1) {
      setInstitute((oldarray) => [...oldarray, insitutedData]);
    } else {
      setInstitute((oldarray) =>
        oldarray.map((el) => {
          if (el.index === i) {
            // return { ...el, value: insitutedData };
            return { ...el, value: e?.value };
          }
          return el;
        })
      );
    }
    let consent1 = {
      index: i,
      value: "",
    };
    if (
      selectedCountry?.length
      // &&
      // Object.keys(selectedCountry[index])?.length
    ) {
      let newAr = selectedCountry;
      newAr[index] = {};
      setSelectedCountry(newAr);
    } else {
      let newAr = selectedCountry;
      newAr[index] = {};
      setSelectedCountry(newAr);
    }

    const found2 = changeSiteNumberType.some((el) => el.index === i);
    if (!found2) {
      setChangeSiteNumberType((oldarray) => [...oldarray, consent1.value]);
    } else {
      const updatedArray = changeSiteNumberType.map((el) =>
        el.index === i ? { ...el, value: consent1.value } : el
      );
      setChangeSiteNumberType(updatedArray);
    }

    let consent2 = {
      index: i,
      value: "",
    };
    const found3 = changeSiteNameType.some((el) => el.index === i);
    if (!found3) {
      setChangeSiteNameType((oldarray) => [...oldarray, consent2.value]);
    } else {
      const updatedArray = changeSiteNameType.map((el) =>
        el.index === i ? { ...el, value: consent2.value } : el
      );
      setChangeSiteNameType(updatedArray);
    }

    const found5 = changeCountry.some((el) => el.index === i);
    if (!found5) {
      setChangeCountry((oldarray) => [...oldarray, consent1]);
    } else {
      const updatedArray = changeCountry.map((el) =>
        el.index === i ? { ...el, value: consent1.value } : el
      );
      setChangeCountry(updatedArray);
    }

    const consent3 = {
      index: i,
      value:
        e?.value == "Study site"
          ? change?.userIrtRoles[0]?.value
          : change?.role[4]?.value,
    };

    const found4 = changeRoleType.some((el) => el.index === i);
    if (!found4) {
      setChangeRoleType((oldarray) => [...oldarray, consent3]);
    } else {
      const updatedArray = changeRoleType.map((el) =>
        el.index === i ? { ...el, value: consent3.value } : el
      );
      setChangeRoleType(updatedArray);
    }

    setSelectedSiteNumber((prev) => {
      const newSelectedSiteNumber = [...prev];
      newSelectedSiteNumber[index] = true;
      return newSelectedSiteNumber;
    });

    setSelectedSiteName((prev) => {
      const newSelectedSiteName = [...prev];
      newSelectedSiteName[index] = true;
      return newSelectedSiteName;
    });

    // setSelectedRole((prev) => {
    //   const newSelectedRole = [...prev];
    //   newSelectedRole[index] = true;
    //   return newSelectedRole;
    // });
    setSelectedRole((prev) => {
      const newSelectedSiteName = [...prev];
      newSelectedSiteName[index] =
        e?.value == "Study site" ? change?.userIrtRoles[0] : change?.role[4];
      return newSelectedSiteName;
    });

    let consetValue = e.value;
    const filteredData = change.sideData.filter(
      (item) => item.country === consetValue
    );

    const siteNumbers = filteredData.map((item) => ({
      label: item.site_number,
      value: item.site_number,
    }));
    const siteNames = filteredData.map((item) => ({
      label: item.site_name,
      value: item.site_name,
    }));
    setSiteNumber((prevSiteNumbers) => ({
      ...prevSiteNumbers,
      [index]: siteNumbers,
    }));
    setSiteName((prevSiteNumbers) => ({
      ...prevSiteNumbers,
      [index]: siteNames,
    }));

    let consetValueType = e.value == "Study site" ? 1 : 0;
    let consent = {
      index: i,
      value: parseInt(consetValueType),
    };

    const foundIndex = changeIRTType.findIndex((el) => el.index === i);
    if (foundIndex === -1) {
      setChangeIRTType((oldarray) => [...oldarray, consent]);
    } else {
      setChangeIRTType((oldarray) =>
        oldarray.map((el) => {
          if (el.index === i) {
            return { ...el, value: parseInt(consetValueType) };
          }
          return el;
        })
      );
    }

    // readerDataList[index].role = "";
    readerDataList[index].siteName = "";
    readerDataList[index].siteNumber = "";
    readerDataList[index].country = "";
    setReaderDataList(readerDataList);

    changeUpdateFlag.push(i);
    setChangeUpdateFlag(changeUpdateFlag);
  };
  const handleTimeLine = (data) => {
    // window.open("/timeline-detail");
    localStorage.setItem('irt_sec', 1);
    localStorage.setItem("myData", data);
    window.open("/timeline-detail");
    // const windowProps = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, width=1200, height=800`;
    //  newWindow = window.open("/timeline-detail", " ", "");
    //  newWindow.opener.postMessage({readerId:data}," ")
  };

  const onSiteNumberChange = (e, i, index) => {
    const selectedSiteNumber = e.value;
    const selectedItem = change.sideData.find(
      (item) => item.site_number === selectedSiteNumber
    );
    const selectedCountry1 = selectedItem.country;
    const selectedName = selectedItem.site_name;

    let consent = {
      index: i,
      value: selectedCountry1,
    };
    const found1 = changeCountry.some((el) => el.index === i);
    if (!found1) {
      setChangeCountry((oldarray) => [...oldarray, consent]);
    } else {
      const updatedArray = changeCountry.map((el) =>
        el.index === i ? { ...el, value: selectedCountry1 } : el
      );
      setChangeCountry(updatedArray);
    }
    let consent1 = {
      index: i,
      value: selectedName,
    };
    setSelectedCountry((prev) => {
      const newSelectedCountry = [...prev];
      newSelectedCountry[index] = {
        value: selectedCountry1,
        label: selectedCountry1,
      };
      return newSelectedCountry;
    });

    setSelectedSiteName((prev) => {
      const newSelectedSiteName = [...prev];
      newSelectedSiteName[index] = {
        value: selectedName,
        label: selectedName,
      };
      return newSelectedSiteName;
    });

    setSelectedSiteNumber((prev) => {
      const newSelectedSiteNumber = [...prev];
      newSelectedSiteNumber.splice(index, 1, {
        value: e.value,
        label: e.value,
      });
      return newSelectedSiteNumber;
    });

    const found2 = changeSiteNameType.some((el) => el.index === i);
    if (!found2) {
      setChangeSiteNameType((oldarray) => [...oldarray, consent1]);
    } else {
      const updatedArray = changeSiteNameType.map((el) =>
        el.index === i ? { ...el, value: selectedName } : el
      );
      setChangeSiteNameType(updatedArray);
    }
    let consetValue = e.value;
    consent = {
      index: i,
      value: consetValue,
    };

    const found = changeSiteNumberType.some((el) => el.index === i);
    if (!found) {
      setChangeSiteNumberType((oldarray) => [...oldarray, consent]);
    } else {
      const index = changeSiteNumberType.findIndex((el) => el.index === i);
      let updatedArray = [...changeSiteNumberType];
      updatedArray[index].value = consetValue;
      setChangeSiteNumberType(updatedArray);
    }
    changeUpdateFlag.push(i);
    setChangeUpdateFlag(changeUpdateFlag);
  };
  const onSiteNameChange = (e, i, index) => {
    const selectedSiteName = e.value;
    const selectedItem = change.sideData.find(
      (item) => item.site_name === selectedSiteName
    );
    const selectedCountry = selectedItem.country;
    const selectedSiteNumber = selectedItem.site_number;

    let consent = {
      index: i,
      value: selectedCountry,
    };
    const found1 = changeCountry.some((el) => el.index === i);
    if (!found1) {
      setChangeCountry((oldarray) => [...oldarray, consent]);
    } else {
      const updatedArray = changeCountry.map((el) =>
        el.index === i ? { ...el, value: selectedCountry } : el
      );
      setChangeCountry(updatedArray);
    }

    let consent1 = {
      index: i,
      value: selectedSiteNumber,
    };
    const found2 = changeSiteNumberType.some((el) => el.index === i);
    if (!found2) {
      setChangeSiteNumberType((oldarray) => [...oldarray, consent1]);
    } else {
      const updatedArray = changeSiteNumberType.map((el) =>
        el.index === i ? { ...el, value: selectedSiteNumber } : el
      );
      setChangeSiteNumberType(updatedArray);
    }

    let consent2 = {
      index: i,
      value: selectedSiteName,
    };
    const found3 = changeSiteNameType.some((el) => el.index === i);
    if (!found3) {
      setChangeSiteNameType((oldarray) => [...oldarray, consent2]);
    } else {
      const updatedArray = changeSiteNameType.map((el) =>
        el.index === i ? { ...el, value: selectedSiteName } : el
      );
      setChangeSiteNameType(updatedArray);
    }

    setSelectedCountry((prev) => {
      const newSelectedCountry = [...prev];
      newSelectedCountry[index] = {
        value: selectedCountry,
        label: selectedCountry,
      };
      return newSelectedCountry;
    });

    setSelectedSiteNumber((prev) => {
      const newSelectedSiteNumber = [...prev];
      newSelectedSiteNumber[index] = {
        value: selectedSiteNumber,
        label: selectedSiteNumber,
      };
      return newSelectedSiteNumber;
    });

    setSelectedSiteName((prev) => {
      const newSelectedSiteName = [...prev];
      newSelectedSiteName[index] = {
        value: selectedSiteName,
        label: selectedSiteName,
      };
      return newSelectedSiteName;
    });
    changeUpdateFlag.push(i);
    setChangeUpdateFlag(changeUpdateFlag);
  };

  const updateReaderDetails = async (reader_id, index, pre_role) => {
    try {
      loader("show");
      const tindex = changeUserType.findIndex((el) => el.index === reader_id);
      let type = "";
      if (tindex !== -1) {
        type = changeUserType[tindex].value;
      }
      let body = {};
      let role = "";
      let irt = "";
      let siteNumber = "";
      let siteName = "";
      let country = "";
      let binded = "";
      let institute = "";
      let blockReminder = ""

      if (isLikeRdAccount) {
        const roleIndex = changeRoleType.findIndex(
          (el) => el.index === reader_id
        );

        if (roleIndex !== -1) {
          role = changeRoleType[roleIndex]?.value;
        } else {
          const roleIndex = readerDataList.findIndex(
            (el) => el.id === reader_id
          );
          role = readerDataList[roleIndex]?.role;
        }

        const irtIndex = changeIRTType.findIndex(
          (el) => el.index === reader_id
        );

        if (irtIndex !== -1) {
          irt = changeIRTType[irtIndex]?.value;
        } else {
          const irtindex = readerDataList.findIndex(
            (el) => el.id === reader_id
          );
          irt = readerDataList[irtindex]?.irt == "Yes" ? 1 : 0;
        }
        const countryIndex = changeCountry.findIndex(
          (el) => el.index === reader_id
        );
        if (countryIndex !== -1) {
          country = changeCountry[index]?.value;
        } else {
          const countryIndex = readerDataList.findIndex(
            (el) => el.id === reader_id
          );
          country = readerDataList[countryIndex]?.country;
        }

        const blindedIndex = changeBlindedType.findIndex(
          (el) => el.index === reader_id
        );
        if (blindedIndex !== -1) {
          binded = changeBlindedType[blindedIndex].value;
        }

        const instituteIndex = instituteValue.findIndex(
          (el) => el.index === reader_id
        );

        if (instituteIndex > -1) {
          institute = instituteValue[instituteIndex]
            ? instituteValue[instituteIndex]?.value
            : "";
        } else {
          const instituteIndex = readerDataList.findIndex(
            (el) => el.id === reader_id
          );
          institute = readerDataList[instituteIndex]?.institution;
        }

        const siteNumberIndex = changeSiteNumberType.findIndex(
          (el) => el.index === reader_id
        );
        if (siteNumberIndex !== -1) {
          siteNumber = changeSiteNumberType[siteNumberIndex].value;
        } else {
          const siteNumberIndex = readerDataList.findIndex(
            (el) => el.id === reader_id
          );
          siteNumber = readerDataList[siteNumberIndex]?.siteNumber;
        }

        const siteNameIndex = changeSiteNameType.findIndex(
          (el) => el.index === reader_id
        );
        if (siteNameIndex !== -1) {
          siteName = changeSiteNameType[siteNameIndex].value;
        } else {
          const siteNameIndex = readerDataList.findIndex(
            (el) => el.id === reader_id
          );
          siteName = readerDataList[siteNameIndex]?.siteName;
        }

        const blockReminderIndex = changeBlockReminderType.findIndex(
          (el) => el.index === reader_id
        );

        if (blockReminderIndex !== -1) {
          blockReminder = changeBlockReminderType[blockReminderIndex]?.value;
        } else {
          const blockReminderIndex = readerDataList.findIndex(
            (el) => el.id === reader_id
          );
          blockReminder = readerDataList[blockReminderIndex]?.blockReminder;
        }
        if (
          country !== "" &&
          (type !== "" ||
            role !== "" ||
            irt !== "" ||
            binded !== "" ||
            siteNumber !== "" ||
            siteName !== "" ||
            institute !== "")
        ) {
          body = {
            type: 1,
            readerId: reader_id,
            userStatus: type,
            country: country,
            binded: binded,
            irt: irt,
            role: role,
            institute: institute,
            siteNumber: siteNumber,
            siteName: siteName,
            blockReminder: blockReminder
          };
        } else {
          toast.warning("Please select country.");
          return;
        }
      } else {
        const index = changeCountry.findIndex((el) => el.index === reader_id);

        //let country = "";
        if (index !== -1) {
          country = changeCountry[index].value;
        }

        if (country !== "" || type !== "") {
          loader("show");
          body = {
            type: 0,
            readerId: reader_id,
            userStatus: type,
            country: country,
          };
        }
      }

      if (Object.keys(body)?.length !== 0) {
        const res = await postData(ENDPOINT.READERSTATUSUPDATE, body);
        const libDataIndex = readerDataList.findIndex(
          (el) => el?.id === reader_id
        );
        if (country !== "") {
          readerDataList[libDataIndex].country = country;
        }
        if (type !== "") {
          let userTypeValue = userTypeValues?.[type];
          readerDataList[libDataIndex].user_status = userTypeValue;
        }

        // if (role !== "") {
        readerDataList[libDataIndex].role = role;
        // }

        if (irt !== "") {
          readerDataList[libDataIndex].irt = irt == 1 ? "Yes" : "No";
        }
        if (binded !== "") {
          readerDataList[libDataIndex].binded = binded;
        }
        // if (siteName !== "") {
        readerDataList[libDataIndex].siteName = siteName;
        // }
        // if (siteNumber !== "") {
        readerDataList[libDataIndex].siteNumber = siteNumber;
        // }
        if (institute !== "") {
          readerDataList[libDataIndex].institution = institute;
        }
        if (blockReminder !== "") {
          readerDataList[libDataIndex].blockReminder = blockReminder;
        }

        if(pre_role == role){
          loader("hide");
          const newData = readerDataList;
          setReaderDataList(newData);
          setUpdateFlag(updateflag + 1);
          loader("hide");
          popup_alert({
            visible: "show",
            message: "Your Profile has been updated successfully!",
            type: "success",
            redirect: "",
          });
        }else{
          //if we change role then remove user card from current role
          toast.success("Your Profile has been updated successfully!");
          setActiveTabs({});
          getReaderListData(page, filterObject, search);
        }
      } else {

        toast.warning("Nothing to update.");
      }


    } catch (err) {
      console.log("err", err);
      loader("hide");
    }
  };


  const clearFilter = () => {

    document.querySelectorAll("input")?.forEach((checkbox) => {
      checkbox.checked = false;
    });

    obj = {};
    setAppliedFilter({ });

    if (filterApplyflag > 0) {
      let obj = {
        status: ["Registered"],
        "contact Type": ["HCP"],
      };
      setFilterApplyflag(0);
      setApifilterObject(obj);
      setFilterObject(obj);
      setReaderDataList([]);
      // getReaderListData(page, obj, search);
      getReaderListData(page, obj, "");
      setSearch("");
    }


    if (originalFilterData?.role?.length) {
      setFilterData({ ...filterdata, role: originalFilterData.role });
    }
    if (searchInputRef.current) {
      searchInputRef.current.value = '';
    }

    setShowFilter(false);
  };

  const applyFilter = (e) => {
    e.preventDefault();
    setTotalCountFlag(false);
    setFlag(0);
    setFilterApplyflag(1);
    setReaderDataList([]);
    setFilterObject(appliedFilter);
    getReaderListData(page, appliedFilter, search);
    setShowFilter(false);
  };

  const removeindividualfilter = (key, item) => {
    let old_object = filterObject;

    if (key == "region") {
      let newCountry = country;
      delete old_object.country;

      setFilterData({ ...filterdata, country: newCountry });
    }
    if (item == "All") {
      old_object[key]?.includes(item);
      delete old_object[key];
    } else {
      const index = old_object[key]?.indexOf(item);
      if (index > -1) {
        if (old_object[key].includes("All")) {
          const allIndex = old_object[key]?.indexOf("All");
          old_object[key]?.splice(allIndex, 1);
        }
        old_object[key]?.splice(index, 1);
        if (old_object[key]?.length == 0) {
          delete old_object[key];
        }
      }
    }

    if (Object.keys(old_object)?.length !== 0) {
      setFilterObject(old_object);

      setReaderDataList([]);
      setAppliedFilter(old_object);
      getReaderListData(page, old_object, search);
    } else {
      let obj = {};
      setFilterObject({});
      setAppliedFilter({});
      setApifilterObject({});
      setReaderDataList([]);
      getReaderListData(page, obj, search);
    }
  };

  const tabClicked = async (key, userId, index, country, role) => {
    setApiCallStatus(false);
    setActiveTabs((prevTabs) => ({
      ...prevTabs,
      [userId]: key,
    }));
    if (key == "usage") {
      let index = emailStats.findIndex((el) => el.userId == userId);
      if (index === -1) {
        let normal_data = emailStats;
        try {
          let body = {
            readerId: userId,
            irt: 1,
            role: role,
          };
          const res = await postData(ENDPOINT.READERACTIVITY, body);
          if (res?.data?.data) {
            let new_data = res?.data?.data;
            normal_data.push(new_data);
            setEmailStats(normal_data);
            setStatsFlag(statsFlag + 1);
          }
        } catch (err) {
          console.log(err);
        }
      }
    } else if (
      key == "change-tab" &&
      (isLikeRdAccount)
    ) {
      const res = await getData(ENDPOINT.READER_USER_DROP);

      setChanges(res?.data?.data);
      // setSiteNumber((prevSiteNumbers) => ({
      //   ...prevSiteNumbers,
      //   all: res?.data?.data?.siteNumber,
      // }));
      // setSiteName((prevSiteName) => ({
      //   ...prevSiteName,
      //   all: res?.data?.data?.siteName,
      // }));
      let consetValue = country;
      const filteredData = res?.data?.data?.sideData?.filter(
        (item) => item.country === consetValue
      );

      const siteNumbers = filteredData?.map((item) => ({
        label: item.site_number,
        value: item.site_number,
      }));
      const siteNames = filteredData?.map((item) => ({
        label: item.site_name,
        value: item.site_name,
      }));
      setSiteNumber((prevSiteNumbers) => ({
        ...prevSiteNumbers,
        [index]: siteNumbers,
      }));
      setSiteName((prevSiteNumbers) => ({
        ...prevSiteNumbers,
        [index]: siteNames,
      }));
      axiosFun();
    }
    setApiCallStatus(true);
  };

  const axiosFun = async () => {
    try {
      axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
      const result = await axios.get(`emailapi/get_site?uid=${accountMapping[localStorage.getItem("user_id")] || 2147501188}`);
      let country = result?.data?.response?.data?.site_country_data;
      let arr = [];
      Object.entries(country).map(([index, item]) => {
        let label = item;
        if (index == "B&H") {
          label = "Bosnia and Herzegovina";
        }
        arr.push({
          value: item,
          label: label,
        });
      });

      setIRTCountry(arr);
    } catch (err) {
      console.log("-err", err);
    }
  };

  const showConfirmationPopup = (stateMsg, e, id) => {
    if (stateMsg == "delete") {
      setResetDataId(id);
      setCommonConfirmModelFun(() => deleteUser);
      setPopupMessage({
        message1: "You are about to remove this reader.",
        message2: "Are you sure you want to do this?",
        footerButton: "Yes please!",
      });
      if (confirmationpopup) {
        setConfirmationPopup(false);
      } else {
        setConfirmationPopup(true);
      }
    }
  };

  const deleteUser = async (id) => {
    loader("show");
    try {
      await deleteData(ENDPOINT.DELETEREADER, id);
      loader("hide");
      popup_alert({
        visible: "show",
        message: "Reader has been deleted <br />successfully !",
        type: "success",
        redirect: "",
      });

      const updatedRes = readerDataList.filter((item) => item.id !== id);
      setReaderDataList(updatedRes);
      // }
      loader("hide");
    } catch (err) {
      loader("hide");
    }
    hideConfirmationModal();
  };

  const hideConfirmationModal = () => {
    setConfirmationPopup(false);
  };
  const Refresh = async (obj) => {
    try {
      setRefreshFlag(true);

      let data = {
        user_id: localStorage.getItem("user_id"),
        userType: 5,
        search: search,
        type: "",
        flag: isFlag,
        page: 1,
        limit: limit,
      };
      let payload = { ...data, ...obj };
      const res = await postData(ENDPOINT.READER_REFRESH, payload);
      setCount(res?.data?.data?.total);

      // setRefreshFlag(false);
    } catch (err) {
      console.log(err);
      // setRefreshFlag(false);
    }
  };

  const createNewEmail = async(user_id,role) => {
    
    let pdfid = allMandatoryRole?.[role] ? allMandatoryRole?.[role] : rolePdf;
    let irtRoleObj = {};

    const roleMap = {
      'Investigator-Blinded': 'Investigator-Blinded',
      'Site User-Blinded': 'Site User-Blinded',
      'Site unblinded pharmacist': 'Site Unblinded Pharmacist',
      'Site Unblinded Pharmacist': 'Site Unblinded Pharmacist',
      'Site Unblinded pharmacist': 'Site Unblinded Pharmacist',
      'Site unblinded Pharmacist': 'Site Unblinded Pharmacist',
    };

    const normalizedSiteRole = roleMap[state?.siteRole] || roleMap[role];
    // if(state?.siteRole == 'Investigator-Blinded' || role == 'Investigator-Blinded'){
    //   pdfid = rolePdf;
    //   irtRoleObj = {pdfId: rolePdf, IRTFlag: 1, siteRole: 'Investigator-Blinded'}
    // }else if(state?.siteRole == 'Site User-Blinded'  || role == 'Site User-Blinded'){
    //   pdfid = rolePdf;
    //   irtRoleObj = {pdfId: rolePdf, IRTFlag: 1, siteRole: 'Site User-Blinded'};
    // }else if(state?.siteRole == 'Site unblinded pharmacist' || state?.siteRole ==  'Site Unblinded Pharmacist' || state?.siteRole ==  'Site Unblinded pharmacist' || state?.siteRole ==  'Site unblinded Pharmacist' || role ==  'Site unblinded Pharmacist'){
    //   pdfid = rolePdf;
    //   irtRoleObj = {pdfId: rolePdf, IRTFlag: 1, siteRole: 'Site Unblinded Pharmacist'}
    // }

    if (normalizedSiteRole) {
        irtRoleObj = { pdfId: pdfid, IRTFlag: 1, siteRole: normalizedSiteRole };
    }

    if(pdfid != 0){
      let userDetails = [];
      var reducHcp = user_id.split();
      let body = {
        user_id: localStorage.getItem("user_id"),
        readers_id: reducHcp,
      };
      loader("show");
      await axios
      .post(`emailapi/get_user_details`, body)
      .then((res) => {
        userDetails = res.data.response.data;
      })
      .catch((err) => {
        console.log(err);
      });


      try {
        const body = {
          user_id: localStorage.getItem("user_id"),
          pdf_id: pdfid,
          role: irtRoleObj?.siteRole
        };
        axios.defaults.baseURL = process.env.REACT_APP_API_KEY;
        
        await axios
          .post(`emailapi/get_rd_campaign_data`, body)
          .then((res) => {
            if (res.data.status_code == 200) {
              let campaign_data = res?.data?.response?.data;
              campaign_data['startTraining'] = 1;
              props.getEmailData(campaign_data);
              props.getSelected(userDetails);
            } else {
              toast.warning(res.data.message);
            }
            loader("hide");
          })
          .catch((err) => {
            loader("hide");
            toast.error("Something went wrong");
          });
          // console.log(irtRoleObj,'irtRoleObj')
        navigate("/VerifyHcpMAIL", {
          state: { IrtObj: irtRoleObj, NextFlag: 1 },
        });
      } catch (err) {
        loader("hide");
        console.log(err, 'err');
      }
    }
  }

  const getRefreshData = async() => {
    try{
      let obj = {
        "sync":1,
        created_by:createdBy
      };
      const response = await postDataRd(ENDPOINT.INDIVIDUAL_TRAINING_COMPLETION_V2,obj);
      getReaderListData(page, filterObject, search);
    }catch(err){
      console.log(err);
    }
  }

  const refreshCronData = () => {
    setRefreshFlag(true);
  }

  const EditClick = (user_id,role) => {
    let pdfid = allMandatoryRole?.[role] ? allMandatoryRole?.[role] : rolePdf;
    if(isLikeRdAccount){
      navigate("/mandatory-reader-edit", {
        state: { id: user_id, status: '1', siteRole: state?.siteRole, pdfId: pdfid },
      });
    }else{
      navigate("/reader-edit", {
        state: { id: user_id, status: '1', siteRole: state?.siteRole, pdfId: pdfid },
      });
    }
  }

  return (
    <>
      <Col className="right-sidebar custom-change">
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <div className="custom-container">
          <Row>
           

            <div className={`library-content-box-layuot readerlist d-flex ${isRDAccount ? "rd": ""}`}>
            <div className="site-irt w-100">
                <div className="page-title d-flex align-items-center flex-wrap">
                      <h4>
                         Trials
                      </h4>
            
                  {/* {!isLikeRdAccount ? (<>
                    {(
                      <div className="refresh-button">
                        <button
                          className={refreshFlag ? "refresh-rotate" : "refresh"}
                          onClick={async () => {
                            // setRefreshFlag(true);

                            let createdBy = localStorage.getItem("user_id")
                            let obj = {
                              "sync": 1,
                              created_by: createdBy
                            };
                            const response = await postData("https://onesource.informed.pro/api/training-completion-cron", obj);
                            const hadData = response?.data?.data || [];
                            // setRefreshFlag(false);

                          }}
                        >
                          <svg
                            fill="#fff"
                            height="800px"
                            width="800px"
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            // xmlns:xlink="http://www.w3.org/1999/xlink"
                            viewBox="0 0 383.748 383.748"
                          // xml:space="preserve"
                          >
                            <g>
                              <path
                                d="M62.772,95.042C90.904,54.899,137.496,30,187.343,30c83.743,0,151.874,68.13,151.874,151.874h30
        C369.217,81.588,287.629,0,187.343,0c-35.038,0-69.061,9.989-98.391,28.888C70.368,40.862,54.245,56.032,41.221,73.593
        L2.081,34.641v113.365h113.91L62.772,95.042z"
                              />
                              <path
                                d="M381.667,235.742h-113.91l53.219,52.965c-28.132,40.142-74.724,65.042-124.571,65.042
        c-83.744,0-151.874-68.13-151.874-151.874h-30c0,100.286,81.588,181.874,181.874,181.874c35.038,0,69.062-9.989,98.391-28.888
        c18.584-11.975,34.707-27.145,47.731-44.706l39.139,38.952V235.742z"
                              />
                            </g>
                          </svg>
                        </button>
                      </div>
                    )}
                  </>)
                    : null} */}

                  {/* {isLikeRdAccount ? (<>
                    {(
                      <>
                    <button className={refreshFlag ? "refresh-rotate" : "refresh"} title="Refresh"onClick={refreshCronData} >
                    <svg fill="#0066be" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 383.748 383.748"><g><path d="M62.772,95.042C90.904,54.899,137.496,30,187.343,30c83.743,0,151.874,68.13,151.874,151.874h30
                    C369.217,81.588,287.629,0,187.343,0c-35.038,0-69.061,9.989-98.391,28.888C70.368,40.862,54.245,56.032,41.221,73.593
                    L2.081,34.641v113.365h113.91L62.772,95.042z"></path><path d="M381.667,235.742h-113.91l53.219,52.965c-28.132,40.142-74.724,65.042-124.571,65.042
                    c-83.744,0-151.874-68.13-151.874-151.874h-30c0,100.286,81.588,181.874,181.874,181.874c35.038,0,69.062-9.989,98.391-28.888
                    c18.584-11.975,34.707-27.145,47.731-44.706l39.139,38.952V235.742z"></path></g></svg>
                </button>
                      <br/>
                    <p style={{fontSize:"11px",color:"#97B6CF",flex:"0 0 100%",marginTop:"3px"}}>Last Sync : {lastSync}</p>
                    </>
                    )}
                  </>)
                    : null} */}

                </div> 
              </div>
              <TrialCompletionTable createdBy={createdBy} 
                    pathImage={path_image}
                    appliedFilters={appliedFilter}
                    filterdata={filterdata}
                    setFilterData={setFilterData}
                    onLastUpdatedChange={setLastSync}
              />
            </div>
            {/* <div className="load_more">
              {isLoaded == true ? (
                <Button
                  className="btn btn-primary btn-filled"
                  onClick={loadMoreClicked}
                >
                  Load More
                </Button>
              ) : null}
            </div> */}

            {/* {pageAll == true ? (
              <div
                className="load_more"
                style={{
                  margin: "0 auto",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <Spinner color="#53aff4" size={32} speed={1} animating={true} />
              </div>
            ) : null} */}
          </Row>
        </div>
      </Col>

      {/* <CommonConfirmModel
        show={confirmationpopup}
        onClose={hideConfirmationModal}
        fun={commonConfirmModelFun}
        popupMessage={popupMessage}
        path_image={path_image}
        resetDataId={resetDataId}
      /> */}
    </>
  );
};


const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps, {
  getDraftData: getDraftData,
  getSelectedSmartListData: getSelectedSmartListData,
  getEmailData: getEmailData,
  getSelected : getSelected,
})(TrailReadersView);

// export default NewReadersReview;
